import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';

export interface BakeasyHeaderLabelProps {
  message: string;
  icon?: any;
  style?: React.CSSProperties;
}

function BakeasyHeaderLabel(props: BakeasyHeaderLabelProps) {
  return (
    <Grid sx={{ marginBottom: 1 }} display={'flex'} flexDirection={'row'} alignItems={'center'}>
      {props?.icon && <props.icon />}
      <Typography
        sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}
        marginLeft={props?.icon ? 0.5 : 0}
      >
        {t(props?.message)}
      </Typography>
    </Grid>
  );
}

export default BakeasyHeaderLabel;

export function BakeasyFilterHeaderLabel(props: BakeasyHeaderLabelProps) {
  return (
    <Grid display={'flex'} flexDirection={'row'} alignItems={'center'}>
      {props?.icon && <props.icon />}
      <Typography sx={{ fontWeight: 'bold' }} marginLeft={props?.icon ? 0.5 : 0}>
        {t(props?.message)}
      </Typography>
    </Grid>
  );
}
